<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="4" :sm="12">
            <el-form-item label="编码:">
              <el-input v-model.trim="table.where.uuid" placeholder="请输入设备编码" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="类型:">
              <el-select v-model="table.where.type" placeholder="请选择类型" class="ele-block" clearable>
                <el-option label="蓝牙" value="1" />
                <el-option label="扫码" value="2" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12">
            <el-form-item label="选择日期:">
              <el-date-picker v-model="table.where.createDay" placeholder="请选择日期" type="date" value-format="yyyy-MM-dd" class="ele-fluid" />
            </el-form-item>
          </el-col>
          <el-col :md="5" :sm="12">
            <el-form-item label="班级:">
              <treeselect
                v-model="table.where.classId"
                :options="classTree"
                :disable-branch-nodes="true"
                placeholder="请选择所属班级"
                :defaultExpandLevel="4"
                :normalizer="
                  (d) => {
                    return { id: d.id, label: d.name };
                  }
                "
              />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table class="table" ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 260px)" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="teacherName" label="教师姓名" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="branchName" label="部系" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="gradeName" label="年级" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="className" label="班级" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="classTime" label="课程时间" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="clockTime" label="签到时间" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="createDay" label="日期" sortable="custom" show-overflow-tooltip />
        </template>
      </ele-data-table>
    </el-card>
  </div>
</template>
<script>
  import { getAllClassTree } from '@/config/api';
  import Treeselect from '@riophae/vue-treeselect';
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  export default {
    name: '',
    components: { Treeselect },
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/teacherClass/page',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
        classTree: [],
      };
    },
    mounted() {
      this.queryClassTree();
    },
    methods: {
      /* 查询班级树 */
      queryClassTree() {
        getAllClassTree().then((res) => {
          if (res.data.resCode == 200) {
            this.classTree.push(res.data.data);
            this.deleteChildren(this.classTree);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              if (data[i].orgType !== 4) {
                delete data[i].children;
                data[i].isDisabled = true;
              }
            }
          }
        }
        return data;
      },
    },
  };
</script>

<style scoped lang="scss"></style>
